module.exports = __webpack_public_path__ + "img/toright.4d56dc32.png";